<template>
  <div v-if="readable" :class="`input ${editable ? '' : 'disabled'} ${viewdata}`">
    <label>{{fielddata.label}}</label>
		<ckeditor v-if="fielddata.content_editor"
			:editor="editor"
			:value="fieldvalue"
			@input="update"
			:config="editorConfig"></ckeditor>
		<div v-else>
			<div
				:contentEditable="editable"
				:class="itemdata.length > 1 ? 'batched edit' : 'edit'"
				@keyup="keyup"
				@change="keyup"
				@paste="paste"
				>{{fieldvalue}}</div>
			<div ref="mask" class="mask"></div>
		</div>
  </div>
</template>

<script>
import _ from 'lodash';
import Data from '../../main';
import CKEditor from '@ckeditor/ckeditor5-vue';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

export default {
	name: 'DynamicInput',
	props: {
		item: Array,
		field: Object,
		view: String,
	},
	components: {
		ckeditor: CKEditor.component
	},
	computed: {
		// lodash in template
		_() {
			return _;
		},
	},
	watch: {
		item: function() {
			this.itemdata = this.item;
			this.setFieldvalue();
		},
	},
	data() {
		//  this.field.model = _.defaultTo(this.field.model, '');
		return {
			fielddata: this.field,
			itemdata: this.item,
			viewdata: this.view,
			editable: Data.fieldWriteable(this.field.id, Data),
			readable: Data.fieldReadable(this.field.id, Data),
			editor: ClassicEditor,
			fieldvalue: '',
			editorConfig: {
				removePlugins: ['ImageUpload'],
			},
		};
	},
	mounted(){
		this.setFieldvalue();
	},

	created() {
		const that = this;

		this.setFieldvalue = () =>{
			this.fieldvalue = this.itemdata.length == 1 ?
				_.get(this.itemdata[0],  [this.fielddata.model, this.fielddata.name].filter(Boolean).join('.') )
				: '';

				if(this.$refs.mask && this.fieldvalue && this.fielddata.char_limit)
					this.$refs.mask.innerHTML = this.fieldvalue.slice(0, this.fielddata.char_limit)
					+  '<span>' + this.fieldvalue.slice(this.fielddata.char_limit) + '</span>';
		}

		// sanitize pasted html
		this.paste = (e) => {
			var clipboardData, pastedData;

			e.stopPropagation();
	    e.preventDefault();

	    clipboardData = e.clipboardData || window.clipboardData;
	    pastedData = clipboardData.getData('Text').replace(/<[^>]*>?/gm, '');

			let selection = document.getSelection()
			let range = selection.getRangeAt(0)
			let el = e.target;

	    let v = el.innerText;
	    let textBefore = v.substring(0, range.startOffset);
	    let textAfter  = v.substring(range.endOffset, v.length);
	    let mergedText = textBefore + pastedData + textAfter;
			//var caretFinal = textBefore + pastedData

			el.innerText = mergedText;
			that.item[0][that.field.name] = mergedText;
			this.setFieldvalue();

			// set caret back but it will highlight all (bug).
			range.setStartBefore(el,0);
			range.setEndAfter(el,1);
			selection.addRange(range);
		};


		this.keyup = (e) => {

			var value = e.target ? e.target.innerText : e;

			if(this.$refs.mask && value && this.fielddata.char_limit)
				this.$refs.mask.innerHTML = value.slice(0, this.fielddata.char_limit)
				+  '<span>' + value.slice(this.fielddata.char_limit) + '</span>';

			value = Data.sanitize(value);
			this.update(value,e);
		};

		// / unique debounce update fn on each component life cycle
		this.update = _.debounce(function(value, e) {

			if (that.viewdata == 'full') {
				return that.$emit('saveTrigger', {
					name: that.field.name,
					value,
					model: that.field.model
				});
			}

			that.$Progress.start();
			that.$axios
				.put('/item', {
					batch: [that.item[0].id],
					update: {[that.field.name]: value},
				})
				.then((response) => {
					// update dataset on blur so render won't alter cursor position
					e.target.onblur = () => {
						that.item[0][that.field.name] = value;
					};

				})
				.catch((error) => {
					that.$notify({
						group: 'main',
						title: 'Something went wrong.',
						text: 'Please try again.',
						type: 'warn',
					});
					console.log(error);
				})
				.finally(()=>{
					that.$Progress.finish();
				});
		}, 500);
	}
};
</script>

<style scoped lang="less">
  input, textarea{
    border:none;
    outline:none;
    width: 100%;
    height: 85%;
  }
  input{
    height: 20px;
  }

  .input, div{
    height:100%;
    outline:none;
  }
	.input > div{
		position:relative;
	}
	.input .mask{
		position:absolute;
		top:0;
		left:0;
		color:#fff;
	}
	.input .edit{
		position:relative;
		z-index: 1;
	}

  .input > div div{
    padding: 2px;
  }
  .input div:focus{
    outline:2px solid #101480;
  }
  .full .edit{
    border: 1px solid #efefef;
    margin-bottom: 20px;
  }
  .inline label{
    display: none;
  }

  .batched[contentEditable=true]:not(:focus):before{
    display: inline-block;
    content:'[Batched Editing]';
    color:grey;
  }
</style>

<style>
.input .mask span{
	background:#ffe0af;
}
</style>
